var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('modularMenu',{attrs:{"type":_vm.type},on:{"peopleChange":_vm.peopleChange}}),_c('router-view',{ref:"childmain"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }